
import { defineComponent } from "vue";

export default defineComponent({
  name: "GameIntro",
  data: () => ({
    showModal: false,
    isEnable : false
  }),
  methods: {
    playGame() {
      window.showOrHideIntro(false);
      window.showOrHideInstructionPopup1(true);
    },
    showPopup(show: boolean) {
      this.showModal = show;
    },
    enablePlay(show: boolean) {
      console.log(show)
      this.isEnable = show;
    }
  },
  mounted() {
    window.showOrHideIntro = this.showPopup;
    window.enablePlay = this.enablePlay;
  }
});
